export default __webpack_public_path__ + "static/media/slack.50496294.svg";